'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _debugger = require('../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

var _handleInstreamError = require('../player/utils/handleInstreamError');

var _handleInstreamError2 = _interopRequireDefault(_handleInstreamError);

var _getAdswizzListenerId = require('../utils/getAdswizzListenerId');

var _getAdswizzListenerId2 = _interopRequireDefault(_getAdswizzListenerId);

var _logging = require('../player/constants/logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line consistent-return
exports.default = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(requestUrl) {
    var _tuner$streamPlayer$g, timeout, isInstreamLoggingEnabled, host, _get, palNonce, ppid, gdprTcString, gdprApplies, isOptedOut, _get$dfpParams, dfpParams, adsParams, adswizzListenerId, response, _response$data, manifestUrl, trackingUrl;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _debugger2.default.log('attempting to fetch master manifest url', requestUrl);
            _tuner$streamPlayer$g = _tuner2.default.streamPlayer.getPlayerConfig(), timeout = _tuner$streamPlayer$g.timeout, isInstreamLoggingEnabled = _tuner$streamPlayer$g.isInstreamLoggingEnabled;
            _context.prev = 2;
            host = requestUrl.substring(0, requestUrl.indexOf('/v1'));
            _get = (0, _get3.default)(_tuner2.default, 'tune.params', {}), palNonce = _get.palNonce, ppid = _get.ppid, gdprTcString = _get.gdprTcString, gdprApplies = _get.gdprApplies, isOptedOut = _get.isOptedOut, _get$dfpParams = _get.dfpParams, dfpParams = _get$dfpParams === undefined ? {} : _get$dfpParams;

            // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
            // see https://docs.google.com/document/d/1J2XU_0TN5Ix_vLdcuJd-h6vdHdPQvc2wc8fSLNu3ojA

            adsParams = (0, _extends3.default)({
              ciu_szs: '300x250,728x90',
              gdfp_req: '1',
              cust_params: _tuner2.default.instreamCustParams || '',

              // this represents combined consent under CCPA and GDPR
              // if the GDPR TC String is available, this will simply be ignored
              // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
              npa: isOptedOut ? '1' : '0' }, dfpParams);


            if (palNonce) {
              adsParams.paln = palNonce;
            }

            // gdprApplies can be undefined until OneTrust determines whether GDPR applies
            if ((0, _isBoolean2.default)(gdprApplies)) {
              // IMPORTANT: ADS PARAMS ATTRIBUTES MUST BE STRINGS
              adsParams.gdpr = gdprApplies ? '1' : '0';
            }

            if (gdprTcString) {
              adsParams.gdpr_consent = gdprTcString;
            }

            if (ppid) {
              adsParams.ppid = ppid;
            }

            adswizzListenerId = (0, _getAdswizzListenerId2.default)();

            if (adswizzListenerId) {
              adsParams.rdid = adswizzListenerId;
              adsParams.idtype = 'adid';
            }

            _context.next = 14;
            return _axios2.default.post(requestUrl, { adsParams: adsParams }, { timeout: timeout });

          case 14:
            response = _context.sent;
            _response$data = response.data, manifestUrl = _response$data.manifestUrl, trackingUrl = _response$data.trackingUrl;

            if (!manifestUrl) {
              _context.next = 18;
              break;
            }

            return _context.abrupt('return', {
              trackingUrl: trackingUrl && '' + host + trackingUrl,
              manifestUrl: '' + host + manifestUrl
            });

          case 18:
            throw new Error('manifestUrl missing from response');

          case 21:
            _context.prev = 21;
            _context.t0 = _context['catch'](2);

            _debugger2.default.log('Fetching master manifest url: ' + _context.t0.message, _context.t0);

            (0, _handleInstreamError2.default)(_context.t0, _logging.actions.instreamPostTimeout, _logging.actions.instreamPostError, isInstreamLoggingEnabled);

            throw new Error('Fetching master manifest url: ' + _context.t0.message);

          case 26:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 21]]);
  }));

  function getMasterManifestUrl(_x) {
    return _ref.apply(this, arguments);
  }

  return getMasterManifestUrl;
}();
//# sourceMappingURL=getMasterManifestUrl.js.map